<img [src]="('./assets/ionicons/' + icon + '.svg')">
